import { Storage } from "@xt/xtbase";

const RECOMMENDED_FIAT_PLATE_ID = 258;

function hasFiatTradeSymbol(item) {
  return Number(item?.isSymbolExist) === 1;
}

function isRecommendedFiatItem(item) {
  const plates = Array.isArray(item?.plates) ? item.plates : [];
  return plates.some((plateId) => Number(plateId?.id ?? plateId) === RECOMMENDED_FIAT_PLATE_ID);
}

function getRecommendedCurrencies() {
  const payload = Storage.get("recommendedCurrencyList") || {};
  return Array.isArray(payload.currencies) ? payload.currencies : [];
}

export function getDynamicFiatMarketCodes() {
  const currencies = getRecommendedCurrencies();
  const codes = [];
  currencies.forEach((item) => {
    const code = String(item?.currency || item?.currencyCode || item?.coinName || "").toUpperCase();
    if (isRecommendedFiatItem(item) && hasFiatTradeSymbol(item) && code && !codes.includes(code)) {
      codes.push(code);
    }
  });
  return codes;
}

export function isFiatMarketCode(code) {
  if (!code) return false;
  return getDynamicFiatMarketCodes().includes(String(code).toUpperCase());
}
